<template>
    <div>
        <page-title>账户</page-title>
        <page-body v-loading="loading">
            <div>
                <template v-if="user">
                    <div flex="box:first" style="margin-bottom: 10px">
                        <div style="width: 80px">手机号:</div>
                        <div>{{user.mobile}}</div>
                    </div>
                    <div flex="box:first" style="margin-bottom: 10px">
                        <div style="width: 80px">称呼:</div>
                        <div>{{user.name}}</div>
                    </div>
                    <div flex="box:first" style="margin-bottom: 10px">
                        <div style="width: 80px">QQ号:</div>
                        <div>{{user.qq}}</div>
                    </div>
                    <div flex="box:first">
                        <div style="width: 80px">密码:</div>
                        <div>
                            <el-button style="margin: -12px 0" type="text" @click="showChangePassword = !showChangePassword">{{showChangePassword ?
                                '取消修改密码' : '修改密码'}}
                            </el-button>
                        </div>
                    </div>
                    <change-password v-if="showChangePassword"/>
                </template>
                <template v-else>
                    <div style="text-align: center;color: #909090">暂无信息</div>
                </template>
            </div>
        </page-body>
    </div>
</template>

<script>
export default {
    components: {
        'ChangePassword': () => import('@/components/ChangePassword.vue')
    },
    data() {
        return {
            loading: true,
            showChangePassword: false,
            user: null
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            this.$store.dispatch('getUser').then(e => {
                this.loading = false
                this.user = e
                console.log(e)
            })
        },
        resetPassword() {
        }
    }
}
</script>

<style scoped>

</style>
